import { hitApi, ObservableAjax } from '__common/utils/api';
import { ActionTypes } from 'actionsConstants';
import { SET_WHATS_NEW, CLOSE_WHATS_NEW } from './WhatsNewActions';
import { shouldAutoOpenWhatsNew } from './whatsNewHelpers';
import { ActionsObservable } from 'redux-observable';
import { AnyAction, Store } from 'redux';
import { Observable } from 'rxjs';

export function getWhatsNew(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(ActionTypes.GET_WHATS_NEW)
    .switchMap(action =>
      ObservableAjax({
        onSuccess: (data) => {
          const autoOpen = action.payload && action.payload.autoOpen;
          const { user } = store.getState();
          const hasUnseen = shouldAutoOpenWhatsNew(
            data.latest_major_release_id,
            data.show_popup,
            user && user.isAuthenticated,
          );
          const open = autoOpen && hasUnseen;
          return SET_WHATS_NEW(data.releases, data.latest_major_release_id, open, hasUnseen);
        },
        onErrorMessage: 'Could not fetch release notes',
        link: hitApi('get', `api/v1/whats_new/`),
      }));
}

export function dismissWhatsNew(action$: ActionsObservable<AnyAction>, store: Store<appState>): Observable<any> {
  return action$.ofType(ActionTypes.DISMISS_WHATS_NEW)
    .switchMap(action =>
      ObservableAjax({
        onSuccess: () => CLOSE_WHATS_NEW(),
        onErrorMessage: 'Could not update release notes preference',
        link: hitApi('post', `api/v1/whats_new/dismiss/`, {}),
      }));
}
